const MinusIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10.25c0-5.524 4.476-10 10-10s10 4.476 10 10-4.476 10-10 10-10-4.476-10-10zm18.286 0c0-4.571-3.715-8.286-8.286-8.286S1.714 5.68 1.714 10.25 5.43 18.536 10 18.536s8.286-3.715 8.286-8.286zm-13.905-1h11.238l-.043 1.948-11.195.052v-2z" fill="currentColor"
    />
  </svg>
)

export default MinusIcon
